<template>

  <div class="login-wrapper">
    <a href="https://www.complyon.com/" class="mt-3 ml-3 white-logo">
      <img src="@/assets/complyon-white.png" style="width: auto; height: 35px;" class="mt-3">
    </a>
    <a href="https://www.complyon.com/" class="mt-3 ml-3 black-logo">
      <img src="@/assets/complyon_logo.svg" style="width: auto; height: 35px;" class="mt-3">
    </a>
    <span class="login-credits">
      Photo by
      <a href="https://www.tiredofbeingmild.com/">@tiredofbeingmild</a>
    </span>
    <!-- <div class="row">
      <div class="col-sm-12 col-md-6">
        <div class="login-carousel">
          <Carousel :autoplay="true" :perPage="1" :loop="true" :autoplayTimeout="5000">
            <Slide>
              <img src="@/assets/login-image-1.jpg" style="width: auto; height: 100vh">
            </Slide>
            <Slide>
              <img src="@/assets/login-image-2.jpg" style="width: auto; height: 100vh">
            </Slide>
            <Slide>
              <img src="@/assets/login-image-3.jpg" style="width: auto; height: 100vh">
            </Slide>
            <Slide>
              <img src="@/assets/login-image-4.jpg" style="width: auto; height: 100vh">
            </Slide>
          </Carousel>
        </div>
      </div>
      <div class="col-sm-12 col-md-6"> -->
        <div class="login">
          <div class="reset-block p-3">
            <h1 class="text-darker text-bold">
              {{ $t('reset_password.title') }}
            </h1>
            <br>
            <h5 class="text-dark" qid="reset-password-description" v-if="!showMicrosoftButton && !showGoogleButton">
              {{ $t('reset_password.description') }}
            </h5>
            <h5 class="text-dark" qid="verify-microsoft-description" v-if="showMicrosoftButton">
              {{ $t('reset_password.microsoft_description') }}
            </h5>
            <h5 class="text-dark" qid="verify-google-description" v-if="showGoogleButton">
              {{ $t('reset_password.google_description') }}
            </h5>
            <b-alert v-if="form.wrongCredentials"
                     show
                     variant="danger"
                     qid="reset-password-error"
            >
              {{ $t('auth.token_is_invalid') }} {{$t('auth.click')}}

              <router-link
                      to="/login?reset=true"
              >
                {{ $t('auth.here') }}
              </router-link>

            {{$t('auth.request_new_password')}}
            </b-alert>
            <b-form @submit="onSubmit" qid="reset-password-form" v-if="!showMicrosoftButton && !showGoogleButton">
              <div class="form-container">
                <b-form-group v-if="!getEmail">
                  <b-form-input
                    qid="input-reset-email"
                    type="email"
                    v-model="form.email"
                    required
                    :placeholder="$t('reset_password.email_placeholder')"
                  ></b-form-input>
                </b-form-group>
                <p class="text-dark mb-3" v-if="getEmail">
                  {{ getEmail }}
                </p>
                <b-form-group>
                  <b-form-input
                    type="password"
                    qid="input-reset-password"
                    v-model="form.password"
                    required
                    :state="validationPass"
                    :placeholder="$t('reset_password.password_placeholder')"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validationPass">
                    {{ $t('reset_password.notice.password_requirement') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                  <b-form-input
                    type="password"
                    qid="input-reset-repeatPassword"
                    v-model="form.repeatPassword"
                    required
                    :state="validationRepeatPass"
                    :placeholder="$t('reset_password.repeat_password_placeholder')"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validationRepeatPass">
                    {{ $t('reset_password.notice.do_not_match') }}
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback
                    :state="validationRepeatPass"
                    v-if="form.repeatPassword && form.repeatPassword.length"
                  >
                    {{ $t('reset_password.notice.looks_good') }}
                  </b-form-valid-feedback>
                </b-form-group>
              </div>
              <b-button type="submit"
                        variant="success"
                        :disabled="buttonDisabled"
                        class="btn-block pt-3 pb-3"
                        qid="button-submit-reset-password"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('reset_password.button') }}
              </b-button>
            </b-form>
            <div class="row" v-if="showMicrosoftButton">
              <div class="col-sm-12 mt-4">
                <button
                   class="btn btn-block btn-secondary pt-3 pb-3"
                   qid="login-microsoft-button"
                   @click="handleMicrosoftLogin"
                >
                  <font-awesome-icon :icon="['fab', 'microsoft']"/>
                  {{ $t('login.microsoft_button') }}
                </button>

              </div>
            </div>
            <div class="row" v-if="showGoogleButton">
              <div class="col-sm-12 mt-4">
                <button
                    class="btn btn-block btn-secondary pt-3 pb-3"
                    qid="login-microsoft-button"
                    @click="handleGoogleLogin"
                >
                  <font-awesome-icon :icon="['fab', 'google']"/>
                  {{ $t('login.google_button') }}
                </button>
              </div>
            </div>
          </div>
        </div>
  </div>

</template>

<script>
import piincHttp from '@/util/configureAxios.js'
import { Carousel, Slide } from 'vue-carousel';

export default {
  components: {
    Carousel,
    Slide
  },
  data: function() {
    return {
      form: {
        email: '',
        password: '',
        repeatPassword: '',
        submitted: false,
        wrongCredentials: false,
        errorMessage: ''
      },
      showForgotPasswordSuccessMessage: false,
      buttonDisabled: false,
      showMicrosoftButton: false,
      showGoogleButton: false
    }
  },
  computed: {
    getToken() {
      return this.$route.params.token
    },
    getEmail() {
      return this.$route.query.email
    },
    validationPass() {
      let containsCapital = RegExp('[A-Z]');
      let containsSpecial = RegExp('\\W');

      return this.form.password && this.form.password.length > 7 && containsCapital.test(this.form.password) && containsSpecial.test(this.form.password);
    },
    validationRepeatPass() {
      return this.form.repeatPassword && this.form.password === this.form.repeatPassword;
    }
  },
  methods: {
    redirectOnlogin() {
      this.$router.push('/login');
    },
    handleMicrosoftLogin() {
      window.location.href = '/api/auth/azure';
    },
    handleGoogleLogin() {
      window.location.href = '/api/auth/google';
    },
    onSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      let self = this;
      evt.preventDefault();


      piincHttp.post('password/reset', {
        email: this.form.email,
        password: this.form.password,
        password_confirmation: this.form.repeatPassword,
        token: this.getToken
      }).then(function() {
        self.buttonDisabled = false;
        setTimeout(self.redirectOnlogin, 500);
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false
          self.form.wrongCredentials = true;
          self.form.errorMessage = error.data.message;
        }
      })

    },
  },
  // Lifecycle hooks
  created() {

    let self = this;

    if (this.getEmail) {
      this.form.email = this.getEmail

      piincHttp.get('users/reset/' + this.getToken + '/' + this.getEmail, {
        email: this.getEmail,
        token: this.getToken
      }).then(function(response) {
        self.buttonDisabled = false;
        if (response.data.user.authentication == 'Microsoft') {
          self.showMicrosoftButton = true;
        }
        if (response.data.user.authentication == 'Google') {
          self.showGoogleButton = true;
        }
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false
          self.form.wrongCredentials = true;
          self.form.errorMessage = error.data.message;
        }
      })
    }

  }
}
</script>
